import React, { Component } from "react";


class InstructorInfo extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={}
}
 
componentDidMount(){
}


  render() {
	 return (
		<div className="booked_pop_content">
			<div className="workout_video_container">
				<div className="close_pops"	onClick={() => this.props.updateStateFromChild({isOpenInstructorInfo: false})}></div>
				<div className="video_name">Instructor</div>
				<div className="instructorInfo_container" >
					<div className="instructorInfoH1" >
						<div className="instructorInfoImg" style={{ backgroundImage: this.props.sessionData.hostImage && this.props.sessionData.hostImage.indexOf('.s3') > -1 ? "url("+this.props.sessionData.hostImage+")" : "url(./images/user_avatar.svg)"}}></div>
						<div className="instructorName_h1">{this.props.sessionData.hostFirstName} {this.props.sessionData.hostLastName}</div>
					</div>
					<div className="bio_container" >
						<div className="instructor_info_bio" dangerouslySetInnerHTML={{__html: this.props.sessionData.instructorText}} ></div>
					</div>
					
				</div>
			</div>
		</div>
    );
  }
}
export default InstructorInfo;
